import { useState } from "react";
import { useTranslation } from "react-i18next";
import { getAxiosInstance } from "../../../utils/axiosInstance";
import { toast } from "react-toastify";
import Modal, { SimpleModalControls } from "../../../components/Modal";
import { Text } from "@chakra-ui/react";


interface DeleteSubCategoryProps extends SimpleModalControls {
    id: string
    name: string,
    resetData: () => void
}

const DeleteSubcategory =(props: DeleteSubCategoryProps) => {
    const { t } = useTranslation("translations");

    const deleteSubCategory = async() => {
        try {
            await getAxiosInstance().delete(`/Categories/`, {params: {id: props.id}});
            props.resetData();
            toast.success(t("CATEGORY_DELETED_SUCCESSFULLY"), { position: toast.POSITION.BOTTOM_RIGHT});
            props.onClose();
          } catch (e) {
            toast.error(t("SOMETHING_WENT_WRONG"), { position: toast.POSITION.BOTTOM_RIGHT});
          } finally {
           
          }
    }

    return(
        <>
        <Modal
        header={t("Delete Category")}
        isOpen={props.isOpen}
        onClose={props.onClose}
        secondaryActionName={t("Delete")}
        secondaryActionEnabled={true}
        secondaryAction={() => deleteSubCategory() }
      >
        <Text> {t("Are you sure you want to delete subcategory")} {props.name.toUpperCase()} ?</Text>
      
      </Modal>
        </>
    )
}


export default DeleteSubcategory